<template>
  <CenterFeatures v-if="centerId" :center-id="centerId" />
</template>
<script setup lang="ts">
import { ROUTES, useRouteOf } from "../routing/routes";
import { ref, watch } from "vue";
import CenterFeatures from "../../components/Center/CenterFeatures.vue";

const route = useRouteOf<typeof ROUTES.regionCenterFeatures>();
const centerId = ref<number>();
watch(
  () => route.params.id,
  (value) => (centerId.value = parseInt(value, 10)),
  { immediate: true },
);
</script>
